export default {
  uploadFiles: state => state.files,
  totalUploadCount: state => state.files.length,
  totalSize: state => state.files.reduce((total, item) => total + item.size, 0),
  unUploadFiles: state => state.files.filter(file => file.status === 'ready'),
  unUploadCount: (state, getters) => getters.unUploadFiles.length,
  incompleteUploadCount: state => state.files.filter(file => file.status !== 'success').length,
  cancelToken: state => state.cancelToken,
}
